import RoomEnclosure from "./RoomEnclosure";

export default function Room() {
	return (
		<>
			<RoomEnclosure />
		</>
	);
}
